export const GENRE_TAXONOMY = {
  'Fantasy': {
    icon: '🐉',
    subgenres: ['Epic Fantasy', 'Urban Fantasy', 'Dark Fantasy', 'Portal Fantasy', 'Cosy Fantasy', 'Fairy Tale Retelling', 'Grimdark', 'Mythpunk'],
  },
  'Science Fiction': {
    icon: '🚀',
    subgenres: ['Space Opera', 'Hard SF', 'Cyberpunk', 'Climate Fiction', 'Time Travel', 'First Contact', 'Dystopian', 'Biopunk'],
  },
  'Mystery': {
    icon: '🔍',
    subgenres: ['Cozy Mystery', 'Noir', 'Police Procedural', 'Amateur Sleuth', 'Legal Thriller', 'Heist', 'Gothic Mystery'],
  },
  'Romance': {
    icon: '🌹',
    subgenres: ['Contemporary Romance', 'Historical Romance', 'Paranormal Romance', 'Romantic Suspense', 'Enemies to Lovers', 'Second Chance'],
  },
  'Horror': {
    icon: '🌑',
    subgenres: ['Psychological Horror', 'Supernatural Horror', 'Body Horror', 'Gothic Horror', 'Cosmic Horror', 'Folk Horror'],
  },
  'Historical Fiction': {
    icon: '⚔️',
    subgenres: ['Ancient World', 'Medieval', 'Renaissance', 'Georgian / Regency', 'Victorian', 'World War I', 'World War II', 'Cold War'],
  },
  'Literary Fiction': {
    icon: '📜',
    subgenres: ['Coming of Age', 'Family Saga', 'Social Commentary', 'Autofiction', 'Experimental', 'Stream of Consciousness'],
  },
  'Memoir': {
    icon: '✍️',
    subgenres: ['Personal Memoir', 'Travel Memoir', 'Grief Memoir', 'Recovery Memoir', 'Career Memoir'],
  },
  'Non-fiction': {
    icon: '📚',
    subgenres: ['Narrative Non-fiction', 'Essay Collection', 'Biography', 'Self-help', 'Popular Science', 'Nature Writing'],
  },
  'Young Adult': {
    icon: '🌟',
    subgenres: ['YA Fantasy', 'YA Contemporary', 'YA Science Fiction', 'YA Thriller', 'YA Romance', 'YA Historical'],
  },
  'Middle Grade': {
    icon: '🧡',
    subgenres: ['MG Adventure', 'MG Fantasy', 'MG Mystery', 'MG Contemporary', 'MG Science Fiction'],
  },
  'Short Fiction': {
    icon: '✦',
    subgenres: ['Flash Fiction', 'Short Story Collection', 'Novella', 'Epistolary', 'Fable / Allegory'],
  },
}

export const GENRE_NAMES = Object.keys(GENRE_TAXONOMY)

export function getSubgenres(genre) {
  return GENRE_TAXONOMY[genre]?.subgenres || []
}

export function getGenreIcon(genre) {
  return GENRE_TAXONOMY[genre]?.icon || '📖'
}
